import {createAction, props} from '@ngrx/store'

const commonPrefix = '[common]'

export const show_error_action = createAction(`${commonPrefix} show_error_action`, props<{ data: any; error: any }>())

export const show_success_msg_after_updation_action = createAction(
  `${commonPrefix} show_success_msg_after_updation_action`,
  props<{ moduleName: string }>()
)
export const show_success_msg_action = createAction(`${commonPrefix} show_success_action`, props<{ msg: string }>())
